import { TimelineMax, Power3 } from 'gsap';

const RailPictureHover = (element) => {
  const upperLine = element.querySelector('.rail-picture__top-line');
  const bottomLine = element.querySelector('.rail-picture__bottom-line');

  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start')
    .to(upperLine, 0.6, {
      scaleX: 0,
      transformOrigin: '100% 50%',
      ease: Power3.easeInOut,
    }, 'start')
    .to(upperLine, 0.6, {
      scaleX: 1,
      ease: Power3.easeInOut,
      transformOrigin: '0% 50%',
    }, 'start+=0.6')
    .to(bottomLine, 0.6, {
      scaleX: 0,
      transformOrigin: '100% 50%',
      ease: Power3.easeInOut,
    }, 'start')
    .to(bottomLine, 0.6, {
      scaleX: 1,
      ease: Power3.easeInOut,
      transformOrigin: '0% 50%',
    }, 'start+=0.6');
  return tl;
};

export default RailPictureHover;
